var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        title: "Zoho " + _vm.module + " Picker",
        "ok-text": "Seçimi Tamamla",
        "cancel-text": "İptal",
        className: "zoho-record-picker-modal",
      },
      on: {
        ok: _vm.handleConfirm,
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "zoho-record-picker" },
        [
          _c("a-table", {
            attrs: {
              columns: _vm.columns,
              "data-source": _vm.records,
              "row-selection": {
                selectedRowKeys: _vm.selectedKeys,
                onChange: _vm.onSelectionChange,
              },
              loading: _vm.loading,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }